import React from 'react';
import { BanknoteIcon, CpuIcon, UsersIcon, GlobeIcon } from 'lucide-react';
import { pillars } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
const icons = [BanknoteIcon, CpuIcon, UsersIcon, GlobeIcon];
export function BoardPillars() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-69" data-mp="2sxdmn4pp9k1u">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-70" data-mp="2sxvoqhz1msho">
        <PageHeader overline="Board-Level Competencies" title="Four pillars of governance-ready leadership" description="Each pillar reflects direct, quantified accountability at enterprise scale — the competencies nominating committees evaluate first." data-id="element-71" data-mp="3gmf056de3ldz" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:gap-8" data-id="element-72" data-mp="3bnc3oabh6nhm">
          {pillars.map((pillar, index) => {
          const Icon = icons[index];
          return <article key={pillar.title} className="group flex flex-col bg-parchment-light p-8 transition-colors duration-200 ease-out hover:bg-white lg:p-10" data-id="element-73" data-mp="1vbych2b9bje6" data-mpi={index}>
                <div className="flex items-start justify-between gap-4" data-id="element-74" data-mp="14eya530uwjlx">
                  <span className="flex h-12 w-12 items-center justify-center rounded-t-2xl bg-emerald-50" data-id="element-75" data-mp="14h18cac5xj1q">
                    <Icon className="h-5 w-5 text-emerald transition-transform duration-200 ease-out group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-76" data-mp="1icd1weel13h2" />
                  </span>
                  <span className="font-display text-lg text-brass-200" data-id="element-77" data-mp="1nelxzjmr4lne">0{index + 1}</span>
                </div>

                <h2 className="mt-7 font-display text-2xl leading-snug text-navy" data-id="element-78" data-mp="2145uw8tnioos">{pillar.title}</h2>
                <p className="mt-4 font-sans text-sm leading-relaxed text-navy-400" data-id="element-79" data-mp="1w75rk5o6s01d">
                  {pillar.summary}
                </p>

                <ul className="mt-auto space-y-4 pt-8" data-id="element-80" data-mp="2b10s8oe6uj1h">
                  {pillar.points.map(point => <li key={point} className="flex gap-3" data-id="element-81" data-mp="2d7ia0s5xthm3">
                      <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" data-id="element-82" data-mp="2d9346gocayjf" />
                      <span className="font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-83" data-mp="2n4mvsqvvfb2d">
                        {point}
                      </span>
                    </li>)}
                </ul>
              </article>;
        })}
        </div>
      </div>
    </section>;
}